import { useState } from "react";
import { Search, Heart, Star, Calendar, Users } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const HOTELS = [
  { id: "grace",  name: "Hotel Gracery Shinjuku",   loc: "Shinjuku, Tokyo",  price: "$185", rating: 4.6, reviews: 1248,
    img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=500&q=70" },
  { id: "park",   name: "Park Hyatt Tokyo",         loc: "Shinjuku, Tokyo",  price: "$620", rating: 4.8, reviews: 892,
    img: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=500&q=70" },
  { id: "mitsui", name: "Mitsui Garden Hotel",      loc: "Ginza, Tokyo",     price: "$210", rating: 4.4, reviews: 610,
    img: "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=500&q=70" },
  { id: "station",name: "The Tokyo Station Hotel",  loc: "Tokyo Station",    price: "$450", rating: 4.7, reviews: 955, saved: true,
    img: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=500&q=70" },
];
const FILTERS = ["All", "Hotels", "Apartments", "Resorts", "More"];

export default function MspHotels() {
  const [q, setQ] = useState("Tokyo, Japan");
  const [f, setF] = useState("Hotels");
  return (
    <MspShell title="Hotels" testid="msp-hotels">
      <div className="bg-white rounded-2xl border border-slate-200 flex items-center gap-2 px-4 py-3 shadow-sm">
        <Search className="w-4 h-4 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="msp-hotels-search"
          className="flex-1 bg-transparent outline-none text-slate-800" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="bg-white rounded-2xl border border-slate-200 flex items-center gap-2 px-4 py-3 text-sm text-slate-700"><Calendar className="w-4 h-4 text-blue-600" /> Mar 28 – Mar 31</div>
        <div className="bg-white rounded-2xl border border-slate-200 flex items-center gap-2 px-4 py-3 text-sm text-slate-700"><Users className="w-4 h-4 text-blue-600" /> 2 Guests</div>
      </div>
      <div className="flex gap-2 overflow-x-auto scrollbar-none" style={{ scrollbarWidth: "none" }}>
        {FILTERS.map((x) => (
          <button key={x} onClick={() => setF(x)} data-testid={`msp-filter-${x.toLowerCase()}`}
            className={`shrink-0 px-4 py-1.5 rounded-full text-sm font-700 border ${f === x ? "bg-blue-600 text-white border-blue-600" : "bg-white text-slate-600 border-slate-200"}`}>
            {x}
          </button>
        ))}
      </div>

      <div className="space-y-3" data-testid="msp-hotel-list">
        {HOTELS.length === 0 ? (
          <div className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-8 text-center" data-testid="msp-hotels-empty">
            <div className="w-14 h-14 mx-auto rounded-full bg-fuchsia-50 grid place-items-center mb-3">
              <Search className="w-6 h-6 text-fuchsia-600" />
            </div>
            <div className="font-serif font-800 text-lg text-blue-900">No hotels saved</div>
            <p className="text-sm text-slate-500 mt-1 max-w-xs mx-auto">Search a destination above — we'll pull rates from every major site and remember the ones you love.</p>
          </div>
        ) : HOTELS.map((h) => (
          <div key={h.id} data-testid={`msp-hotel-${h.id}`}
            className="flex items-stretch bg-white rounded-3xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-md transition">
            <div className="w-28 shrink-0 relative">
              <img src={h.img} alt="" className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <div className="flex-1 p-4 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-serif font-700 text-base text-slate-900 leading-tight truncate">{h.name}</div>
                  <div className="text-xs text-slate-500 mt-1">{h.loc}</div>
                </div>
                <button aria-label="Save" className={`shrink-0 w-8 h-8 rounded-full grid place-items-center ${h.saved ? "text-rose-500" : "text-slate-400 hover:text-rose-500"}`}>
                  <Heart className={`w-4 h-4 ${h.saved ? "fill-rose-500" : ""}`} />
                </button>
              </div>
              <div className="flex items-center gap-1 text-xs text-amber-600 mt-2">
                <Star className="w-3.5 h-3.5 fill-amber-500 stroke-none" /> <span className="font-700">{h.rating}</span>
                <span className="text-slate-400">({h.reviews})</span>
              </div>
              <div className="text-blue-700 font-800 text-base mt-1">{h.price}<span className="text-xs font-500 text-slate-500"> / night</span></div>
            </div>
          </div>
        ))}
      </div>
    </MspShell>
  );
}
